export const FEE_NOTICE_TIMEZONE = 'Australia/Melbourne';

export const FEE_NOTICE_START = '2026-09-16T00:00:00';

export const FEE_NOTICE_END = '2026-10-06T00:00:00';

export const FEE_NOTICE_POLL_INTERVAL_MS = 60 * 1000;

export const FEE_NOTICE_EFFECTIVE_DATE = '6 October 2026';

export const FEE_NOTICE_ANCHOR_ID = 'new-session-fees';
export const FEE_NOTICE_HEADING_ID = 'new-session-fees-heading';

export const FEE_NOTICE_SCROLL_OFFSET = 140;

export const FEE_NOTICE_SCROLL_GAP = 16;

export const FEE_NOTICE_CONTACT_HREF = 'https://virtualpsychology.amplarhealth.com.au/contact';

export type FeeNoticeCell = {
  readonly id: string;
  readonly title: string;
  readonly service: string;
  readonly fee: string;
  readonly outOfPocket: string;
};

export const FEE_NOTICE_CELLS: readonly FeeNoticeCell[] = [
  {
    id: 'standard-consumer-fee',
    title: 'Standard Consumer Fee',
    service: 'General Psychologist (50 mins)',
    fee: '$245',
    outOfPocket: '$143.45',
  },
  {
    id: 'member-offer',
    title: 'Medibank / ahm / MyHealth Member Offer',
    service: 'General Psychologist (50 mins)',
    fee: '$200',
    outOfPocket: '$98.45',
  },
];

export const FEE_NOTICE_QUALIFIER = `Sessions booked and held before ${FEE_NOTICE_EFFECTIVE_DATE} are charged at current rates.`;

export const FEE_NOTICE_FOOTNOTE_MHTP = 'If you have a valid and current Mental Health Treatment Plan (MHTP) with sessions remaining, you may be eligible to claim a rebate from Medicare after your appointment. The rebate is paid directly to the bank account registered with Medicare, reducing your final out-of-pocket cost. This is an estimate only and depends on whether you have an MHTP and whether you have reached a Medicare safety net.';

export const FEE_NOTICE_FOOTNOTE_FEE = 'The session fee includes any payment processing costs. No additional credit card payment fees will be charged.';
